import { render, staticRenderFns } from "./DpaModuleMenu.vue?vue&type=template&id=1998a6b8&"
import script from "./DpaModuleMenu.vue?vue&type=script&lang=js&"
export * from "./DpaModuleMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports